import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSearch, faSpinner }  from '@fortawesome/fontawesome-pro-regular';
import { UsefHorseSearchService } from '../../../providers/usef-horse-search.service';
import { Usef_horse } from '../../../models/usef/usef_horse';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-usef-horse-search',
  templateUrl: './modal-usef-horse-search.component.html',
styleUrls:  ['./modal-usef-horse-search.component.css']
})
export class ModalUsefHorseSearchComponent extends SmsAbstractAppPage implements OnInit {

	faSearch = faSearch;
  faSpinner = faSpinner;
	search_results: Usef_horse[] = [];
	horse_selected$: EventEmitter<Usef_horse> = new EventEmitter<Usef_horse>();
  loading: boolean = false;

  constructor(public activeModal: NgbActiveModal, private usefHorseSearchService: UsefHorseSearchService) {
  	super();
  }

  ngOnInit() {
  }

  handleUsefHorseIdSearch(search_term: string){
  	this.usefHorseSearchService.getById(search_term).then(search_results => {
  		this.search_results = search_results;
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleUsefHorseNameSearch(search_term: string){
    this.loading = true;
  	this.usefHorseSearchService.getByName(search_term).then(search_results => {
      this.loading = false;
  		this.search_results = search_results;
  	}).catch(error => {
      this.loading = false;
  		this.handleError(error);
  	});
  }

	handleSelect(usef_horse: Usef_horse){
		this.horse_selected$.emit(usef_horse);
	}

}
